type ReviewCategory = 'invoice' | 'receipt' | 'delivery_note' | 'invoice_receipt';

export function calculateReviewTotals({
  category,
  itemsSubtotal,
  paymentsTotal,
  vatRate,
  priceIncludeVat,
}: {
  category: ReviewCategory | null;
  itemsSubtotal: number;
  paymentsTotal: number;
  vatRate: number | null;
  priceIncludeVat: boolean;
}) {
  const subtotal = category === 'receipt' ? paymentsTotal : itemsSubtotal;
  const shouldApplyVat = category !== 'receipt' && !priceIncludeVat && vatRate != null;
  const vatAmount = shouldApplyVat ? subtotal * (vatRate / 100) : 0;
  const total = subtotal + vatAmount;

  return {
    subtotal,
    vatAmount,
    total,
    showVat: category !== 'receipt' && vatRate != null,
  };
}
